// @flow

import { Col } from "antd";
import {
	InlineReservable,
	InlineWait,
	InlineWaiting,
} from "../../mobile/components/icons";
import { pathOr } from "ramda";
import { useTimeAndPeopleAhead } from "hooks/useTimeAndPeopleAhead";
import Accordion from "../../mobile/components/Accordion";
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import styled from "styled-components";
import theme, { getSize, getWeight } from "views/resources/theme";
import { useCurrentBreakpointName } from "react-socks";
import { IconTags } from "../Office/IconTags";
import { Line, Offices, Reserve, Ticket } from "types";
import { LinesGrid } from "lib/constants";
import { getWaitStimated } from "lib/getWaitStimated";
import { useQuery } from "hooks/useQuery";
import { Link } from "react-router-dom";
import { useGlobal } from "reactn";

// interface ILineCard {
// 	line: ?Line;
// 	office: ?Offices;
// 	officeSlug: string;
// 	is_guest: boolean;
// 	registerRut({ rut: string }): Promise<void>;
// }

const LineCard = ({
	line,
	office,
	officeSlug,
	fromGroup,
	registerRut,
	isDisabled,
}) => {
	const [peopleAheadLocal, setPeopleAheadLocal] = useState(0);
	const avgElapsed = pathOr(0, ["raw_tickets", "avg_elapsed", "mean"], line);
	const attentionTypeTicket = pathOr(
		true,
		["options", "attention_type", "tickets"],
		office
	);

	const peopleAhead = line.waiting;

	const {
		wait,
		loading: loadingWait,
		realPeopleAhead,
	} = useTimeAndPeopleAhead(line, officeSlug);
	const oldWait = getWaitStimated(peopleAhead, avgElapsed);

	const realWaitStimated =
		wait && wait > 0
			? Math.min(Number(wait), 180) === 180
				? `+${Math.min(Number(wait), 180)}`
				: Math.min(Number(wait), 180) || "-"
			: loadingWait
			? "-"
			: getWaitStimated(peopleAhead, avgElapsed);

	useEffect(() => {
		setPeopleAheadLocal(realPeopleAhead);
	}, [line]);

	const currentBp = useCurrentBreakpointName();

	const footer = (
		<CardFooter
			line={line}
			realPeopleAhead={peopleAheadLocal}
			wait={wait === 0 ? 0 : realWaitStimated}
			isDisabled={isDisabled}
		/>
	);

	const footerOnlyReserve = <FooterWrap>Solo reservas</FooterWrap>;

	const query = useQuery();
	const temporary = query.get("temporary");

	const route = temporary
		? `${officeSlug}/lines/${line.slug}?temporary=true`
		: `${officeSlug}/lines/${line.slug}`;

	const [config] = useGlobal("UIConfig");

	return (
		<CardWrapper title={line ? line.name : ""} isDisabled={isDisabled}>
			{isDisabled ? (
				<div>
					<div className="topInfo-Wrapper">
						<h3
							style={
								currentBp === "mobile"
									? { fontSize: "15px" }
									: {}
							}
						>
							{line ? line.name : <Skeleton />}
						</h3>
					</div>
					{config && !config.hideLineCardFooter && (
						<div>
							{attentionTypeTicket ? footer : footerOnlyReserve}
						</div>
					)}
				</div>
			) : (
				<Link to={route}>
					<div className="topInfo-Wrapper">
						<h3
							style={
								currentBp === "mobile"
									? { fontSize: "15px" }
									: {}
							}
						>
							{line ? line.name : <Skeleton />}
						</h3>
						<IconTags office={office} line={line} />
					</div>
					{config && !config.hideLineCardFooter && (
						<div>
							{attentionTypeTicket ? footer : footerOnlyReserve}
						</div>
					)}
				</Link>
			)}
		</CardWrapper>
	);
};

LineCard.defaultProps = {
	tickets: [],
};

const CardFooter = ({ wait, realPeopleAhead, line, isDisabled }) => {
	return (
		<FooterWrap isDisabled={isDisabled}>
			<InlineWaiting waiting={realPeopleAhead} size={0.7} />
			<InlineWait wait={wait} size={0.7} />
			{line && line.reservable && (
				<InlineReservable
					size={0.7}
					color={isDisabled ? "#f0f0f0" : theme.colors.secondary}
				/>
			)}
		</FooterWrap>
	);
};

const CardWrapper = styled.div`
	border: 1px solid #f0f0f0;
	box-shadow: 0px 4px 6px -4px rgba(24, 39, 75, 0.12),
		0px 8px 8px -4px rgba(24, 39, 75, 0.08);
	cursor: ${(props) => (props.isDisabled ? "not-allowed" : "pointer")};
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-bottom: 20px;
	height: 88px;
	width: 45%;
	h3 {
		font-size: 14px;
		font-weight: 500;
	}

	@media (max-width: 767px) {
		width: 90%;
		margin-bottom: 20px;
	}

	&:hover {
		border: ${(props) => (props.isDisabled ? "none" : "1px solid #9ac2ff")};
	}

	.topInfo-Wrapper {
		display: flex;
		font-size: 14px;
		font-weight: 500;
		height: 56px;
		justify-content: space-between;
		overflow: hidden;
		line-height: 22px;
		padding: 0.5rem;
		padding-top: 10px;
		text-align: left;
	}
`;

const StyledLine = styled(Col)`
	height: 88px;
	padding: 0 !important;
	border: 1px solid #f0f0f0;
	border-radius: 2px;
	box-shadow: 0px 4px 6px -4px rgba(24, 39, 75, 0.12),
		0px 8px 8px -4px rgba(24, 39, 75, 0.08);
	cursor: pointer;

	&:hover {
		border: 1px solid #9ac2ff;
	}
`;

const FooterWrap = styled.div`
	display: flex;
	align-items: center;
	height: 30px;
	background: ${(props) => (props.isDisabled ? "#f0f0f0" : "#f6faff")};
	border-radius: 0px 0px 2px 2px;
	padding: 0 16px;
`;

export default LineCard;
